module.exports = __webpack_public_path__ + "img/app-icon-platform.404393e4.png";